"use client";
import { FileInput as e } from "../../atoms/FileInput/FileInput.mjs";
import { forwardRef as t } from "react";
import { jsx as n } from "react/jsx-runtime";
//#region src/components/molecules/ImageFileInput/ImageFileInput.tsx
var r = t(({ children: t, state: r = "default", useButtonWrapper: i = !0, multiple: a, ...o }, s) => /* @__PURE__ */ n(e, {
	ref: s,
	state: r,
	useButtonWrapper: i && (r !== "success" || !!a),
	accept: "image/*",
	multiple: a,
	...o,
	children: t
}));
r.displayName = "ImageFileInput";
//#endregion
export { r as ImageFileInput };
